// removed by extract-text-webpack-plugin
module.exports = {"typo":"Header__typo__33HL0","inputPlaceholder":"Header__inputPlaceholder__2OjN7","cartCount":"Header__cartCount__Dhcj7","searchBox":"Header__searchBox__QPicY","headerMain":"Header__headerMain__8Jc0s","menu":"Header__menu__3SoBF","searchBoxExtended":"Header__searchBoxExtended__3iDOO","btn":"Header__btn__fQz5x","signin":"Header__signin__2KPvo","searchIcon":"Header__searchIcon__Kb8ww","searchIconExtended":"Header__searchIconExtended__1s3V3","menusItem":"Header__menusItem__1Z3kT","menuItem":"Header__menuItem__R7vyi","signInContent":"Header__signInContent__28niE"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Header/Header.css
// module id = 196
// module chunks = 0